

































































import { Component, Prop, Watch } from "vue-property-decorator";
import { SkillMatchLookups, AddSkillMatchModel, SimpleLookupModel } from "@/core/models";
import { QuestionnaireService } from "@/core/services";
import { InputSelectCpt, InputDateCpt, InputFieldCpt } from "@/core/components";

import AppVue from "@/AppVue.vue";

@Component({
  components: { InputSelectCpt, InputDateCpt, InputFieldCpt },
})
export default class AddNewMatchSkillDialogCpt extends AppVue {
  @Prop({ default: false }) showDialog: boolean;

  model = new AddSkillMatchModel();
  loading = false;
  lookups = {} as SkillMatchLookups;

  get isOpen() {
    return this.showDialog;
  }

  get isValidForm() {
    return !!this.model.text && !!this.model.skillMatchPillarId && !!this.model.skillMatchTypeId;
  }

  async created() {
    this.initializeLookups();
  }

  private async initializeLookups() {
    this.loading = true;
    try {
      this.lookups = await QuestionnaireService.getSkillMatchLookups();
    } finally {
      this.loading = false;
    }
  }

  private close(result: SimpleLookupModel = null as any) {
    this.model.text = "";
    this.model.skillMatchPillarId = null as any;
    this.model.skillMatchTypeId = null as any;
    this.$emit("close", result);
  }

  private async save() {
    this.loading = true;
    try {
      const result = await QuestionnaireService.addSkillMatch(this.model);
      this.close(result);
    } catch {
      this.notify("Error", "Something went wrong on trasfering client.", "error");
    } finally {
      this.loading = false;
    }
  }
}
